import { BorderRadius, Color, getShadow, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export const TableWrapper = styled.div`
  width: 100%;
  position: relative;
`

interface TableContainerProps {
  isScrolled: boolean
}

export const TableContainer = styled.div<TableContainerProps>`
  width: 100%;
  border: 1px solid ${Color.Grey100};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  overflow: auto;
  ${getShadow('raisedLight')};
  -ms-overflow-style: none;
  scrollbar-width: none;

  /* Hide scrollbar for webkit browsers */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Show shadow on sticky first column when scrolled horizontally */
  ${({ isScrolled }) =>
    isScrolled &&
    `
    td:first-of-type::before,
    th:first-of-type::before {
      opacity: 1;
    }
  `}
`

/* Duplicate sticky header that appears on top */
export const StickyHeaderDuplicate = styled.div<{ isVisible: boolean; isScrolled?: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  border: 1px solid ${Color.Grey100};
  border-radius: ${BorderRadius.R12} ${BorderRadius.R12} 0 0;
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  z-index: ${zIndex.TableStickyHeader};
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(-10px)')};
  background-color: ${Color.White};
  box-shadow: 0 -7px 0 1px ${Color.White};
  overflow: hidden;
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;

  /* Ensure the table inside can be transformed for horizontal scroll */
  table {
    width: 100%;
    transform-origin: left top;
  }

  /* Make only the very first th sticky (first cell of first row) */
  thead tr:first-child th:first-child {
    position: sticky;
    left: 0;
    z-index: ${zIndex.TableStickyHeader + 1};
    background-color: ${Color.White};
  }

  /* Show shadow on sticky column when scrolled horizontally */
  ${({ isScrolled }) =>
    `
    thead tr:first-child th:first-child::before {
      opacity: ${isScrolled ? 1 : 0};
    };
  `}
`

export const TableBody = styled.table`
  width: 100%;
  min-width: 100%;
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  table-layout: auto;
`

interface RightShadowProps {
  showShadow: boolean
}

export const RightShadow = styled.div<RightShadowProps>`
  content: '';
  opacity: 0;
  width: 15px;
  height: 100%;
  border-radius: ${BorderRadius.R12};
  position: absolute;
  top: 0;
  right: 0;
  z-index: ${zIndex.Alert};
  background: linear-gradient(to left, ${transparentize(0.3, Color.Grey200)}, transparent);
  pointer-events: none;
  transition: opacity 0.2s ease;

  ${({ showShadow }) =>
    showShadow &&
    `
    opacity: 1;`}
`
